import { createAction } from 'redux-actions';
import {
  PapiDaSharedUserCalculateEarnings,
  PapiRequestDaSharedUserCalculateEarnings,
} from '@wix/da-papi-types';
import { reduxKey } from './constants';

export const reduxModuleLoaded = createAction(
  `${reduxKey}.EARNINGS_REDUX_READY`,
  () => ({})
);

export const initializeEarningsDisplay = createAction(
  `${reduxKey}.INITIALIZE_EARNINGS_DISPLAY`,
  (
    displayId: string,
    productType: PapiRequestDaSharedUserCalculateEarnings['product_type'],
    isResale: boolean,
    price: number
  ) => ({
    displayId,
    productType,
    isResale,
    price,
  })
);

export const destroyEarningsDisplay = createAction(
  `${reduxKey}.DESTROY_EARNINGS_DISPLAY`,
  (displayId: string) => ({ displayId })
);

export const updatePrice = createAction(
  `${reduxKey}.UPDATE_PRICE`,
  (displayId: string, price: number) => ({
    displayId,
    price,
  })
);

export const updateEstimatedEarnings = createAction(
  `${reduxKey}.UPDATE_EARNINGS`,
  (displayId: string, data: PapiDaSharedUserCalculateEarnings) => ({
    displayId,
    data,
  })
);

export const fetchFailed = createAction(
  `${reduxKey}.FETCH_FAILED`,
  (displayId: string, errorMessage: string) => ({
    displayId,
    errorMessage,
  })
);
